import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const Roshni = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - ROSHNI</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - ROSHNI</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Verse 1]<br/>
                Yeah<br/>
                Tune rakha nai kahika<br/>
                Hu tere saath bhi na khush, tere baad bhi na khush<br/>
                Tum bina hi sahi tha<br/>
                Ab tujhpar bhi kya likh du dard mai?<br/>
                Jab tu hi mita deti dard thi<br/>
                Aur khudko dafna kar mai de deta saas tujhe<br/>
                Kehta wo tha mera farz hi, yeah<br/>
                <br/>
                [Chorus]<br/>
                Mile log kahi, mere dost nai<br/>
                Meri soch yahi, rahu aur kahi<br/>
                Raate beet gayi, mili seekh yei<br/>
                Hai umeed yei, mile roshni<br/>
                Mile log kahi, mere dost nai<br/>
                Meri soch yahi, rahu aur kahi<br/>
                Raate beet gayi, mili seekh yei<br/>
                Hai umeed yei, mile roshni<br/>
                <br/>
                [Verse 2]<br/>
                Yaade itni dard se kaapi rooh<br/>
                Khush they saath to fir naraazi kyu<br/>
                Dil ke paas magar wo kaafi door<br/>
                Iltija sirf milne ka fitoor<br/>
                Tere bin tha jindagi jeene chala<br/>
                Kyu fir har pal lagne lag gayi saza<br/>
                Tu hi zakhm hai, tu hi uski dawa<br/>
                Saath jo choota, jeene ki na wajah<br/>
                <br/>
                [Chorus]<br/>
                Mile log kahi, mere dost nai<br/>
                M&#1077;ri soch yahi, rahu aur kahi<br/>
                Raate beet gayi, mili seekh yei<br/>
                Hai umeed yei, mil&#1077; roshni<br/>
                Mile log kahi, mere dost nai<br/>
                Meri soch yahi, rahu aur kahi<br/>
                Raate beet gayi, mili seekh yei<br/>
                Hai umeed yei, mile roshni<br/>
                <br/>
                [Outro]<br/>
                Yeah<br/>
                Mile roshni<br/>
                Hai umeed yei, mile roshni<br/>
                Meri kismat me sirf likhe dard<br/>
                Hai umeed yei, mile roshni
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default Roshni;
